import fontawesome from '@fortawesome/fontawesome'
import solid from '@fortawesome/fontawesome-pro-solid'
import light from '@fortawesome/fontawesome-pro-light'
import regular from '@fortawesome/fontawesome-pro-regular'

fontawesome.library.add(solid)
fontawesome.library.add(light)
fontawesome.library.add(regular)



// WEBPACK FOOTER //
// ./src/core/fontawesome.js